import { ABTestData } from "./ABTestData";


// import { JSONDecoder } from "../../../adobe/serialization/json/JSONDecoder"; // TODO: @HTML5 unhandled JSONDecoder class
import { PathProvider } from "../environment/providers/PathProvider";
import { ExternalLog } from "../../externalLogging/ExternalLog";
import { IOErrorLOFactory } from "../../externalLogging/factories/IOErrorLOFactory";
import { SecurityErrorLOFactory } from "../../externalLogging/factories/SecurityErrorLOFactory";
import { debug } from "../../logging/debug";
import { fatal } from "../../logging/fatal";
import { ABTestTimeoutTrackingEvent } from "../../tracking/ABTestTimeoutTrackingEvent";
import { TrackingCache } from "../../tracking/TrackingCache";
import { TrackingEventIds } from "../../tracking/constants/TrackingEventIds";
import { URLLoader, URLRequest } from "@goodgamestudios/createjs-utilities";

import Event = createjs.Event;
// import HTTPStatusEvent = createjs.HTTPStatusEvent; // TODO: @HTML5 unhandled HTTPStatusEvent class
import IOErrorEvent = createjs.IOErrorEvent;
import SecurityErrorEvent = createjs.SecurityErrorEvent;
// import URLRequestMethod = createjs.URLRequestMethod; // TODO: @HTML5 unhandled URLRequestMethod class

import { Signal } from "signals.js";

export class ABTest {
    /** class logger. */
    /** signal that test-data is ready and initalized. */
    public testIsInitalized: Signal = new Signal();
    /** loader for data-url-request. */
    private loader: URLLoader;
    /** url-request for loader. */
    private request: URLRequest;
    /** variables for url request. */
    private variables: any;
    /** specific data for this test. */
    private _testData: ABTestData;
    /** vo for test data. */
    public get testData(): ABTestData {
        return this._testData;
    }

    /** flag if test-data is ready. */
    private _isReady: boolean = false;
    /** flag if test-data is ready. */
    public get isReady(): boolean {
        return this._isReady;
    }

    /**
     * Constructor
     *
     * @param _testData value object with relevant data for this test
     */
    constructor(_testData: ABTestData) {
        this._testData = _testData;
        this.testIsInitalized.add(this.bindFunction(this.handleTestIsInitalized));
        this.requestDisplayEvent();
    }

    /**
     * requesting data from server for this test
     */
    private requestDisplayEvent(): void {
        /* TODO: @HTML5 unhandled classes
        this.request = new URLRequest(PathProvider.instance.abTestDisplayURL);
        this.request.method = URLRequestMethod.POST;
        //////////////////////////////////////////////
        //  setting variables for post-request
        /////////////////////////////////////////////
        this.variables = {};
        this.variables[ABTestData.TEST_ID] = this._testData._testID;
        this.variables[ABTestData.INSTANCE_ID] = this._testData.instanceID;
        this.variables[ABTestData.NETWORK_ID] = this._testData.networkID;
        this.variables[ABTestData.GAME_ID] = this._testData.gameID;
        this.variables[ABTestData.PLAYER_ID] = this._testData.playerID;
        this.variables[ABTestData.REFERRER] = this._testData.referrer;
        this.variables[ABTestData.ACCOUNT_ID] = this._testData.accountID;
        if (this._testData._caseID > 0 && this._testData._clientID != null && this._testData._clientID != "") {
            this.variables[ABTestData.CASE_ID] = this._testData._caseID;
            this.variables[ABTestData.CLIENT_ID] = this._testData._clientID;
        }
        this.request.data = this.variables;
        debug("sending a-b-test display request: " + this.variables);
        this.loader = new URLLoader();
        this.loader.addEventListener(Event.COMPLETE, this.onDisplayEventComplete);
        this.loader.addEventListener(IOErrorEvent.IO_ERROR, this.onDisplayRequestIOError);
        this.loader.addEventListener(SecurityErrorEvent.SECURITY_ERROR, this.onDisplayRequestIOErrorSecurityError);
        this.loader.addEventListener(HTTPStatusEvent.HTTP_STATUS, this.onDisplayEventHTTPStatus);
        this.loader.load(this.request);
        */
    }

    private onDisplayEventComplete(event: Event): void {
        let jsonString: string = (<URLLoader>(event.target)).data as string;

        debug("receiving answer from a-b-test display request: " + jsonString);
        if (jsonString && jsonString != "") {
            // let jsonData: JSONDecoder; // TODO: @HTML5 unhandled JSONDecoder class
            let jsonData: any;
            let dataObject: any = jsonData.getValue();
            if (dataObject[ABTestData.TEST_ID]) {
                this._testData._testID = Number(dataObject[ABTestData.TEST_ID]);
            }
            if (dataObject[ABTestData.CASE_ID]) {
                this._testData._caseID = Number(dataObject[ABTestData.CASE_ID]);
            }
            if (dataObject[ABTestData.ERROR_MSG]) {
                this._testData.errorMessage = String(dataObject[ABTestData.ERROR_MSG]);
            }
            if (dataObject[ABTestData.CLIENT_ID]) {
                this._testData._clientID = String(dataObject[ABTestData.CLIENT_ID]);
            }
            if (dataObject[ABTestData.CONTENT]) {
                this._testData.content = String(dataObject[ABTestData.CONTENT]);
            }
            if (dataObject[ABTestData.IS_VALID]) {
                let validString: string = String(dataObject[ABTestData.IS_VALID]);
                if (validString == "true") {
                    this._testData.isValid = true;
                }
                else {
                    this._testData.isValid = false;
                }
            }
        }
        else {
            fatal("display event data not valid");
        }
        this.testIsInitalized.dispatch();
    };

    private handleTestIsInitalized(): void {
        this._isReady = true;
    }

    private onDisplayRequestIOError(event: IOErrorEvent): void {
        fatal("ioerror while connecting to ab-testing interface for requesting display event");
        ExternalLog.logger.log(new IOErrorLOFactory(IOErrorLOFactory.GENERAL_LOADER_IO_ERROR, event.text, this.request.url));
        this.handleABTestError();
    };

    private onDisplayRequestIOErrorSecurityError(event: SecurityErrorEvent): void {
        fatal("securityerror while connecting to ab-testing interface for requesting display event");
        ExternalLog.logger.log(new SecurityErrorLOFactory(SecurityErrorLOFactory.GENERAL_LOADER_SECURITY_ERROR, event.text, this.request.url));
        this.handleABTestError();
    };

    // private onDisplayEventHTTPStatus = (event: HTTPStatusEvent) => { // TODO: @HTML5 unhandled HTTPStatusEvent
    private onDisplayEventHTTPStatus(event: any): void {
        let statusCat: number = event.status / 100;
        if (statusCat != 2 && statusCat != 3) {
            this.handleABTestError();
        }
    };

    private handleABTestError(): void {
        this._testData.errorMessage = "timeout for display request";
        this._testData.errorCode = ABTestData.STATUS_TIMEOUT_ERROR;
        let trackEvent: ABTestTimeoutTrackingEvent = (<ABTestTimeoutTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.AB_TEST_TIMEOUT_TRACKING));
        trackEvent.testID = this.testData._testID;
        trackEvent.playerId = this.testData.playerID;
        trackEvent.accountID = this.testData.accountID;
        TrackingCache.getInstance().sendEvent(TrackingEventIds.AB_TEST_TIMEOUT_TRACKING);
    }

    /**
     * send a conversion event to backend for this test
     *
     * @param _playerID global id of player
     * @param _instanceID id of current instance
     * @param _referrer url of website containing this flash-client
     */
    public sendConversion(_playerID: number, _instanceID: number, _referrer: string): void {
        if (this._isReady == false) {
            this._testData.errorCode = ABTestData.STATUS_NOT_READY_ERROR;
        }
        this._testData.playerID = _playerID;
        this._testData.instanceID = _instanceID;
        this._testData.referrer = _referrer;
        this._testData.save();
        let request: URLRequest = new URLRequest(PathProvider.instance.abTestTrackURL);
        /*
        request.method = URLRequestMethod.POST;
        let variables: any = {};
        variables[ABTestData.TEST_ID] = this._testData._testID;
        variables[ABTestData.CASE_ID] = this._testData._caseID;
        variables[ABTestData.CLIENT_ID] = this._testData._clientID;
        variables[ABTestData.NETWORK_ID] = this._testData.networkID;
        variables[ABTestData.GAME_ID] = this._testData.gameID;
        variables[ABTestData.INSTANCE_ID] = this._testData.instanceID;
        variables[ABTestData.PLAYER_ID] = this._testData.playerID;
        variables[ABTestData.REFERRER] = this._testData.referrer;
        variables[ABTestData.ACCOUNT_ID] = this._testData.accountID;
        variables[ABTestData.ERROR_CODE] = this._testData.errorCode;

        debug("sending a-b-test conversion with data: " + variables);
        request.data = variables;
        let loader: URLLoader = new URLLoader();
        loader.addEventListener(Event.COMPLETE, this.onConversionEventComplete);
        loader.addEventListener(IOErrorEvent.IO_ERROR, this.onConversionIOError);
        //			loader.addEventListener( HTTPStatusEvent.HTTP_STATUS, onConversionEventHTTPStatus );
        loader.load(request);
        */
    }

    //		protected function = ( event:HTTPStatusEvent ) =>
    //		{
    //			let statusCat:int = event.status / 100;
    //
    //			if (statusCat != 2 && statusCat != 3)
    //			{
    //				ExternalLog.logger.log( new HTTPStatusErrorLO( event ), "ABTest.as" );
    //			}
    //		}
    protected onConversionIOError(event: IOErrorEvent): void {
        fatal("error while connecting to ab-testing interface for sending conversion");
    };

    private onConversionEventComplete(event: Event): void {
        debug("conversion for testcase: " + this._testData._testID + " is complete");
    };

    /**
     * make ready for garbage collector
     */
    public dispose(): void {
        this.testIsInitalized.removeAll();
        this.disposeLoader();
        this._testData.save();
        this._testData = null;
    }

    /**
     * remove all event listener and delete loader
     */
    private disposeLoader(): void {
        if (this.loader) {
            this.loader.removeEventListener(Event.COMPLETE, this.bindFunction(this.onDisplayEventComplete));
            this.loader.removeEventListener(IOErrorEvent.IO_ERROR, this.bindFunction(this.onDisplayRequestIOError));
            this.loader.removeEventListener(SecurityErrorEvent.SECURITY_ERROR, this.bindFunction(this.onDisplayRequestIOErrorSecurityError));
            // this.loader.removeEventListener(HTTPStatusEvent.HTTP_STATUS, this.onDisplayEventHTTPStatus); // TODO: @HTML5 unhandled HTTPStatusEvent class
            this.loader.removeEventListener(Event.COMPLETE, this.bindFunction(this.onConversionEventComplete));
            this.loader.removeEventListener(IOErrorEvent.IO_ERROR, this.bindFunction(this.onConversionIOError));
            //				loader.removeEventListener( HTTPStatusEvent.HTTP_STATUS, onConversionEventHTTPStatus );
            this.loader.close();
            this.loader = null;
        }
    }
}

